import { config } from "../../config"
import { GeneralChat } from "./data-types"


export const getGeneralChatById = async (chatId: string, token?: string, secret?: string): Promise<GeneralChat> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
    authHeaders.token = token
  }

  const res = await fetch(`${config.api.urlV1}/general_chat/${chatId}/${secret ? `?secret=${secret}` : ''}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("chat not found")
  }

  const chat = await res.json()

  return chat
}

export const getGeneralChatList = async (token?: string): Promise<{ meta: { total: number }, data: GeneralChat[]}> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
    authHeaders.token = token
  }

  const res = await fetch(`${config.api.urlV1}/general_chat/list/`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("chat not found")
  }

  const { meta, data } = await res.json()

  return { meta, data }
}

export const getFeedGeneralChats = async (token?: string): Promise<{ meta: { total: number }, data: GeneralChat[]}> => {
    const authHeaders: {[key: string]: string} = {}
    if (token) {
      authHeaders.token = token
    }
  
    const res = await fetch(`${config.api.urlV1}/general_chat/feed/`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        ...authHeaders,
      },
    })
  
    if (res.status !== 200) {
      throw new Error("chat not found")
    }
  
    const { meta, data } = await res.json()
  
    return { meta, data }
}

export const joinGeneralChat = async (chatId: number, token: string, secret?: string): Promise<void> => {
  const res = await fetch(`${config.api.urlV1}/general_chat/${chatId}/join/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      token,
    },
  })

  if (res.status !== 200) {
    throw new Error("club not found")
  }
}

export const leaveGeneralChat = async (chatId: number, token: string): Promise<void> => {
  const res = await fetch(`${config.api.urlV1}/general_chat/${chatId}/leave/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      token,
    },
  })

  if (res.status !== 200) {
    throw new Error("club not found")
  }
}

export const createPrivateChat = async (name: string, description: string, picture: File | null, token: string): Promise<GeneralChat> => {
  const reqBody = new FormData()
  reqBody.append("name", name)
  reqBody.append("description", description)

  if (picture) {
      reqBody.append("picture", picture!)
  }

  const res = await fetch(`${config.api.urlV1}/general_chat/create_private/`, {
    method: "POST",
    headers: {
      token,
    },
    body: reqBody,
  })

  if (res.status !== 200) {
    throw new Error("Unexpected error")
  }

  const parsed: { data: GeneralChat, Error: string | null } = await res.json()

  const { data, Error: error } = parsed

  if (error) {
    throw new Error(error)
  }

  return data
}